/* ============
 * purchase Status Transformer
 * ============
 *
 * The transformer for the purchaseStatuses.
 */

import Transformer from './transformer';

export default class purchaseStatusesTransformer extends Transformer {

  static fetch(purchaseStatuses) {
    return {
      id: purchaseStatuses.id,
      name: purchaseStatuses.name,
    };
  }

  static send(purchaseStatuses) {
    return {
      id: purchaseStatuses.id,
      name: purchaseStatuses.name,
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/transformers/purchaseStatus.js